// extracted by mini-css-extract-plugin
export default {"root":"CommonSection_root__nZuqf","title":"CommonSection_title__WmoC0","text":"CommonSection_text__SP3Yi","whiteLink":"CommonSection_whiteLink__9IQ8y"};